// hooks/useNotificationSound.js
import { useRef, useCallback, useEffect } from 'react';

export const useNotificationSound = (soundUrl = '/notification.mp3') => {
  const audioRef = useRef(null);
  useEffect(() => {
    // Initialize audio
    audioRef.current = new Audio(soundUrl);
    audioRef.current.volume = 0.5; // 50% volume
    
    // Preload the audio
    audioRef.current.load();

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, [soundUrl]);

  const playSound = useCallback(() => {
    if (!audioRef.current) return;

    // Reset audio to start if already playing
    audioRef.current.currentTime = 0;
    
    // Play with error handling (for autoplay policy)
    audioRef.current.play().catch((error) => {
      console.warn('Notification sound blocked:', error);
      // Optionally show a UI message to enable sounds
    });
  }, []);



  const setVolume = useCallback((volume) => {
    if (audioRef.current) {
      audioRef.current.volume = Math.max(0, Math.min(1, volume));
    }
  }, []);

  return { playSound, setVolume };
};